export default {
  SQUARE: 1,
  ROUND: 2,
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/default-settings/layout-style-values.js